import React, { useState, useCallback } from "react";

import SignInPopup from "../../common/SignInPopup";
import { getUserInfo, isUserLogin } from "../../../common/userfuctions";

const UISinginWarpper = ({
  children,
  className = {},
  style = {},
  onClick = () => {},
}) => {
  const [showSignup, setShowSignup] = useState(false);

  const handleClick = async () => {
    const isUser = isUserLogin();
    //const userInfo = await getUserInfo();
    if (isUser) {
      onClick();
    } else {
      setShowSignup(true);
    }
  };

  return (
    <div
      className={className}
      style={style}
      onClick={() => {
        if (!showSignup) handleClick();
      }}
    >
      {showSignup && (
        <SignInPopup
          visible={showSignup}
          onClose={(success) => {
            if (success) {
              onClick();
            }

            setShowSignup(false);
          }}
        />
      )}
      {children}
    </div>
  );
};

export default React.memo(UISinginWarpper);
